import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { OkrMetric } from "server/models"
import { deepCopy, hasAccess, StateType } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
    OkrMetricList,

    LoadOkrMetrics,
    DeleteOkrMetric,

    setOkrMetricList,
    setOkrMetricIds,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Table,
    DeleteRow,
    Button,
} from "client/components"

import Columns from "./columns"
import EditOkrMetric from "./edit"

const List = () => {
    const metricList = useSelector((state: StoreType) => state.okrMetric.metricList)
    const metricIds = useSelector((state: StoreType) => state.okrMetric.metricIds)
    const reloadList = useSelector((state: StoreType) => state.okrMetric.reloadList)

    const defaultMetricsAssigned = useSelector((state: StoreType) => state.system.accountSettings.okr.defaultMetricsAssigned)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        setLoadState(PENDING)
        LoadOkrMetrics(userData.accountId)
        .then((res) => {
            dispatch(setOkrMetricList(res.metricList))
            dispatch(setOkrMetricIds(res.metricIds))
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, defaultMetricsAssigned])

    const onDelete: DeleteRow = (metric: OkrMetric, callback) => {
        DeleteOkrMetric(metric.id, userData.accountId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const metricListCopy: OkrMetricList = metricList ? deepCopy(metricList) : {}
                delete metricListCopy[metric.id]
                dispatch(setOkrMetricList(metricListCopy))
                dispatch(setOkrMetricIds(metricIds.filter((id) => id !== metric.id)))
            })
        })
    }

    const columns = Columns()
    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)

    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                title={lang.metrics}
                columns={columns}
                dataList={metricList}
                dataIds={metricIds}
                rowSize="sm"
                onDelete={onDelete}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addMetric",
                            content: <EditOkrMetric metricId={0} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default List
